// extracted by mini-css-extract-plugin
export default {"date":"style_date__CLQI2"};